import { render } from "./QRCode.vue?vue&type=template&id=d15efb00&scoped=true"
const script = {}

import "./QRCode.vue?vue&type=style&index=0&id=d15efb00&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d15efb00"]])

export default __exports__